import { useMemo } from "react";
import { GraphQLClient } from "graphql-request";
import { useAuthContext } from "../auth/AuthContext";

const GRAPHQL_ENDPOINT =
  process.env.REACT_APP_GRAPHQL_ENDPOINT ?? "http://localhost:5001/api/graphql";

export function useGraphQLClient(): GraphQLClient {
  const { accessToken } = useAuthContext();

  return useMemo(
    () =>
      new GraphQLClient(GRAPHQL_ENDPOINT, {
        headers: accessToken
          ? { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` }
          : { "Content-Type": "application/json" },
      }),
    [accessToken],
  );
}
